var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"meQrcode"}},[_c('div',{staticClass:"qrcode_box"},[(_vm.qrLogo)?_c('img',{ref:"qrcode_logo",staticClass:"qrcode_logo",attrs:{"src":_vm.qrLogo,"alt":"二维码logo"}}):_vm._e(),_c('div',{ref:"canvas",staticClass:"canvas",style:({width:_vm.qrSize+'px',height:_vm.qrSize+'px'}),attrs:{"id":'qrcode_canvas_'+_vm.qrcodeId}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }